export const Pause = () => (
  <>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <rect x="6" y="4" width="4" height="16" fill="#000" />
      <rect x="14" y="4" width="4" height="16" fill="#000" />
    </svg>
  </>
);
